import { LanguageEnum } from 'modules/common/enums';

export const LanguageIdByName: { [key in LanguageEnum]: number } = {
	[LanguageEnum.ENGLISH]: 2,
	[LanguageEnum.YIDDISH]: 1,
	[LanguageEnum.HEBREW]: 3,
}; //TODO mb would be better create a query for this and take it from the server
